import "./LandingCallout.css";

function LandingCallout() {
  return (
    <section className="landing-callout">
      <div className="landing-callout__icon">
        <img src="/bolt.png" alt="" />
      </div>
      <h3 className="landing-callout__title">Haal het maximale rendement uit uw klantcontact</h3>
    </section>
  );
}

export default LandingCallout;
